module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburgerx2-02a49d5bfdb18988302cfa9f9f3b3f28.png";